/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SriSubCategory
 */
export interface SriSubCategory {
    /**
     * 
     * @type {string}
     * @memberof SriSubCategory
     */
    sriSubCategoryId: string;
    /**
     * 
     * @type {string}
     * @memberof SriSubCategory
     */
    sriSubCategoryLabel: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SriSubCategory
     */
    scIds: Array<string>;
}

/**
 * Check if a given object implements the SriSubCategory interface.
 */
export function instanceOfSriSubCategory(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "sriSubCategoryId" in value;
    isInstance = isInstance && "sriSubCategoryLabel" in value;
    isInstance = isInstance && "scIds" in value;

    return isInstance;
}

export function SriSubCategoryFromJSON(json: any): SriSubCategory {
    return SriSubCategoryFromJSONTyped(json, false);
}

export function SriSubCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SriSubCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'sriSubCategoryId': json['sri_sub_category_id'],
        'sriSubCategoryLabel': json['sri_sub_category_label'],
        'scIds': json['sc_ids'],
    };
}

export function SriSubCategoryToJSON(value?: SriSubCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'sri_sub_category_id': value.sriSubCategoryId,
        'sri_sub_category_label': value.sriSubCategoryLabel,
        'sc_ids': value.scIds,
    };
}

